import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-recentactivities',
  templateUrl: './recentactivities.component.html',
  styleUrls: ['./recentactivities.component.css']
})
export class RecentactivitiesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/dashboard/dashboardwidgets/recentactivities/recentactivities.component.ts